import StartComponent from "../components/start/start";
import MainStore from "../store/main-store";

type propsFirstGroup = {
    store: MainStore
}


export default function TolokaFirst ({store}: propsFirstGroup) {
    return (
        <div>
            <StartComponent groupType="" store={store} toloka={true}/>
        </div>
    )
}